export const formatter = currency =>
	new Intl.NumberFormat('hu', {
		style: 'currency',
		currency: currency,
		minimumFractionDigits: 0,
		maximumFractionDigits: 0,
	});
